import {telemetryDebug} from '../../actions/telemetry/telemetryDebug.js'

/**
 * Debug logger for telemetry store operations
 * @internal
 */
export const telemetryStoreDebug = telemetryDebug.extend('telemetryStore')
